import { html, customElement, css } from '@umbraco-cms/backoffice/external/lit';
import { UmbLitElement } from '@umbraco-cms/backoffice/lit-element';
import { UmbTextStyles } from '@umbraco-cms/backoffice/style';

@customElement('umb-folder-workspace-editor')
export class UmbFolderWorkspaceEditorElement extends UmbLitElement {
	override render() {
		return html`<umb-entity-detail-workspace-editor>
			<umb-icon id="icon" slot="header" name="icon-folder"></umb-icon>
			<umb-workspace-header-name-editable slot="header"></umb-workspace-header-name-editable>
		</umb-entity-detail-workspace-editor>`;
	}

	static override styles = [
		UmbTextStyles,
		css`
			#icon {
				display: inline-block;
				font-size: var(--uui-size-6);
				margin-right: var(--uui-size-space-4);
			}
		`,
	];
}

declare global {
	interface HTMLElementTagNameMap {
		'umb-folder-workspace-editor': UmbFolderWorkspaceEditorElement;
	}
}
